@if (dataContext) {
  <div class="astral-stack-l">
    <app-representatives-filter-table
      (selectedContact)="handleRepresentativeForm($event)"
      [control]="form.controls['representative']"
      [service]="contactDataService"
      [serviceOptions]="dataContext.id"
    ></app-representatives-filter-table>
    <p>{{ 'COMMON.OR' | translate }}</p>
    <div class="representative-manager__create-action">
      <astral-button
        variant="primary"
        type="button"
        icon="plus"
        labelKey="REPRESENTATIVE.MANAGER.CREATE_REPRESENTATIVE_BUTTON"
        (click)="handleEditRepresentativeForm()"
      ></astral-button>
    </div>
    <!-- Table with representatives -->
    <app-representative-rows
      (editRepresentative)="handleEditRepresentativeForm($event)"
      [itemsSource]="dataContext.representatives"
      [isBrf]="isBrf"
    ></app-representative-rows>
    <!-- SIDEBAR content -->
    <ng-template #representativeFormSidebarContent>
      @if (representativeFormValue) {
        <app-representatives-form
          [dataContext]="representativeFormValue"
          [isBrf]="isBrf"
          (cancelOperation)="closeRepresentativeFormSidebar()"
          (formSubmitted)="handleRepresentativeFormSubmitted()"
          (formStatusChanged)="handleFormStatusChanged($event)"
          >
        </app-representatives-form>
      }
    </ng-template>
  </div>
}
